import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { getStudentView } from '../../Common/Database';
import AvatarEditorComponent from '../../Components/AvatarCrop';
import { setStudentNames } from '../../redux/slices/nameStudentsSlice';

import './style.scss';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';

const StudentProfile = ({ mail }) => {
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();

  const [student, setStudent] = useState();

  const fetchStudentView = async () => {
    await getStudentView(mail).then(response => {
      const resp = response.val();
      setStudent(resp);
    });
  };

  useEffect(() => {
    fetchStudentView();
  }, []);

  return (
    <div className="profile-page container">
      <div className="decor-item-img"></div>
      <div className="bg-wrap">
        <div className="profile-left">
          <div className="avatar-wrap">
            <div>
              <div className="img-wrap">
                <img
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQW27799DaaOUiGQLEg0W5qf75BOHYK4kwbVQ&usqp=CAU"
                  alt="avatar"
                />
              </div>
            </div>

            <button className="btn more btn-primary" type="button">
              {t('Change photo')}
            </button>
          </div>
          <div className="contacts-wrap">
            <h3>{t('administrator contacts:')}</h3>
            <ul className="contacts-list">
              <li>
                <a href="tel:+380985419812">+380985419812</a>
              </li>
              <li>
                <a href="tel:+380985419811">+380985419811</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="profile-right">
          <div className="info-wrap">
            <h3>{t('personal information')}</h3>
            <div className="content">
              <span className="description">{t('fullName')}</span>
              <div className="name-wrap">
                <span className="name">Лилия Василенко</span>
              </div>
            </div>
          </div>
          <div className="subjects-list-wrap">
            <h3>{t('List of my subjects')}</h3>
            <ul className="subjects-list">
              <li>
                <div>{t('english')}</div>
              </li>
              <li>
                <div>{t('physics')}</div>
              </li>
              <li>
                <div>{t('biology')}</div>
              </li>
            </ul>
          </div>
        </div>

        {/* <div className="modal-awatar-editor">
          <AvatarEditorComponent />
        </div> */}
      </div>
    </div>
  );
};

export default StudentProfile;
